import React from 'react'
import { type Role } from 'services'
import { RoleSelect } from 'components'
import { US_LEADERSHIP_OFFICER_ROLES } from 'utils'

export interface LeadershipOfficerTypeSelectProps {
  value: Role | null
  updateLeadershipOfficerType: (type: Role | null) => void
  disabled: boolean
  label?: string
}

export const LeadershipOfficerTypeSelect: React.FC<LeadershipOfficerTypeSelectProps> = ({
  value,
  updateLeadershipOfficerType,
  disabled,
  label = 'Leadership Officer Type'
}) => {
  const getLeadershipOfficerRoles = (roles: Role[]): Role[] => {
    return roles.filter((role: Role) =>
      Object.values(US_LEADERSHIP_OFFICER_ROLES).includes(role.id)
    )
  }

  return (
    <RoleSelect value={value} updateRole={updateLeadershipOfficerType} getRoleFilter={getLeadershipOfficerRoles} disabled={disabled} label={label}/>
  )
}
